const USER_TRACKING_TYPE = Object.freeze({
  BQ_LOGS: 'BQ_LOGS',
});

export {
  USER_TRACKING_TYPE,
};
